import { Component, inject } from '@angular/core';
import { IdService } from '../../../services/id.service';

@Component({
  selector: 'td-wb-table-card-header',
  templateUrl: 'table-card-header.component.html',
  styleUrls: ['table-card-header.component.scss'],
  host: {
    '[attr.id]': 'id'
  }
})
export class TableCardHeaderComponent {
  private static readonly ID_PREFIX: string = 'td-wb-table-card-header';
  private readonly idService: IdService = inject(IdService);

  readonly id: string = this.idService.generateNamespaceSequentialId(TableCardHeaderComponent.ID_PREFIX);
}